import { CommonModule, NgClass } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ValidationMessageComponent } from '../../../../shared/components/validation-message/validation-message.component';
import { globalDatas } from '../../../../../assets/data/globals';
import { CommonService } from '../../../../core/services/common.service';
import { IConfig, NgxCountriesDropdownModule } from 'ngx-countries-dropdown';
import { NumberOnlyDirective } from '../../../../shared/directives/number-only.directive';
import { Component_Name } from '../../../../core/enums/component-name.enum';
import { NgSelectModule } from '@ng-select/ng-select';


@Component({
  selector: 'app-civil-id-info',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgClass,
    TranslateModule,
    ValidationMessageComponent,
    NgxCountriesDropdownModule,
    NumberOnlyDirective,
    CommonModule,
    NgSelectModule
  ],
  templateUrl: './civil-id-info.component.html',
  styleUrl: './civil-id-info.component.scss'
})
export class CivilIdInfoComponent {
  @Input() civilIdInfoForm?: any;
  @Input() isSubmitted?: boolean;
  @Input() parentComponent!: string;
  @Output() imageUploaded = new EventEmitter<string>();
  @ViewChild('countryDropdown', { static: false, read: ElementRef })
  maritalStatusList = globalDatas.MARITAL_STATUS;
  applicantRelationList = globalDatas.APPLICANT_RELATION;
  placeOfBirthMaxLimit = globalDatas.PLACE_OF_BIRTH_MAX_LIMIT;
  occupationMaxLimit = globalDatas.OCCUPATION_MAX_LIMIT;
  religionLists = globalDatas.RELEGION_LIST;
  gccSalarySlab = globalDatas.GCC_SALARY_SLAB;
  allcountryList: any[] = [];
  subscription: Subscription[] = [];
  // translatedGender!: string;
  relationDetails = history?.state.relationDetails ? history?.state.relationDetails : "";
  blockedCountriesList = globalDatas.BLOCKED_COUNTRIES_IN_DROPDOWN;
  defaultCountryCode = globalDatas.DEFUALT_MOBILE_COUNTRY_CODE.countryCode;
  mobileMaxLimit = globalDatas.MOBILE_NUMBER_MAX_LIMIT;
  private langChangeSubscription: Subscription | null = null;
  customValidations = {
    photoValidation: { required: 'VALIDATION.PHOTO_REQUIRED' },
  }
  selectedCountryConfig: IConfig = {
    hideCode: true,
    hideName: true,
  };
  countryListConfig: IConfig = {
    hideCode: true,
  };
  preferredLanguageList = globalDatas.PREFERRED_LANGUAGE_LIST;
  componentName = Component_Name

  constructor(
    protected translate: TranslateService,
    private commonService: CommonService,
    private el: ElementRef,
  ) {
    this.allcountryList = this.commonService.allCountries.getValue();
  }

  ngOnInit(): void {

    // this.subscription.push(this.otherInfoForm.get('relationToApplicant')?.valueChanges.subscribe((value) => {
    //   value === relationEnum.SPOUSE ?
    //     this.commonService.setRequiredValidation(['MarriageCertImage'], this.otherInfoForm) :
    //     this.commonService.removeRequiredValidation(['MarriageCertImage'], this.otherInfoForm);
    //   if (value === relationEnum.SPOUSE) {
    //     this.otherInfoForm.get('maritalStatus')?.setValue(maritalStatusEnum.MARRIED);
    //   } else {
    //     this.otherInfoForm.get('maritalStatus')?.setValue('');
    //   }
    // }));
  }


  // getGender() {
  //   if (this.civilIdInfoForm.get('gender')?.value === 'Male') {
  //     return 'GENDER.MALE'
  //   }
  //   else if (this.civilIdInfoForm.get('gender')?.value === 'Female') {
  //     return 'GENDER.FEMALE'
  //   }
  //   else {
  //     return 'GENDER.OTHERS'
  //   }
  // }


  // ngOnChanges(changes: SimpleChanges) {
  // if (changes['civilIdInfoForm']) {
  // this.translatedGender = this.civilIdInfoForm.get('gender')?.value === 'Female' ?
  //   'GENDER.FEMALE' : this.civilIdInfoForm.get('gender')?.value === 'Male' ?
  //     'GENDER.MALE' : 'GENDER.OTHERS'
  // if (this.isGCCValue) {
  //   this.commonService.removeRequiredValidation(['occupation', 'salary'], this.otherInfoForm);
  // } else {
  //   this.commonService.setRequiredValidation(['occupation', 'salary'], this.otherInfoForm);
  //   if (this.otherInfoForm.get('relationToApplicant')?.value === relationEnum.DOMESTIC_WORKER) {
  //     this.otherInfoForm.get('relationToApplicant')?.setValue('')
  //   }
  // }
  // }
  // }

  ngAfterViewInit() {
    this.setCountryDropDownLanguage(this.translate.currentLang);
    this.langChangeSubscription = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.setCountryDropDownLanguage(this.translate.currentLang);
      }
    );
  }

  setCountryDropDownLanguage(currentLanguage) {
    const countryListElements =
      this.el.nativeElement.querySelectorAll('.ipv_selected-item');
    if (countryListElements.length > 0) {
      countryListElements.forEach((countryListElement: HTMLElement) => {
        const spanElements = countryListElement.querySelectorAll('span');
        spanElements.forEach((span: HTMLElement) => {
          if (currentLanguage == 'en') {
            if (span.innerText.trim() === 'اختر الدولة') {
              span.innerText = 'Select country';
            }
          } else {
            if (span.innerText.trim() === 'Select country') {
              span.innerText = 'اختر الدولة';
            }
          }
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription.forEach(obj => { obj.unsubscribe(); });
    this.langChangeSubscription?.unsubscribe();
  }

  onCountryCodeChange(country: any) {
    this.civilIdInfoForm
      .get('phoneNumberCountryCode')
      ?.setValue(country?.dialling_code || country?.name);
    this.civilIdInfoForm
      .get('phoneNumberCountryISO')
      ?.setValue(country?.code);
  }

  onSelectCountry() {
    // const typeofCountryId = this.allcountryList.filter(
    //   (item) =>
    //     // item.englishName === this.otherInfoForm.value.birthNationality
    // )[0]?.iso3;
    // if (typeofCountryId) {
    //   this.otherInfoForm.patchValue({
    //     birthNationalityCode: typeofCountryId,
    //   });
    // }
  }

  afterProfileImageUpload(event: any) {
    this.imageUploaded.emit(event);

  }

  InputChanges(event: KeyboardEvent): void {
    // Check if the form control or input is disabled
    const disabledControls = [
      'passportNumber',
      'passportExpiryDate',
      'firstName',
      'secondName',
      'thirdName',
      'fourthName',
      'familyName',
      'dateOfBirth',
      'passportNationality',
      'gender'
    ];
    // Check if any of the specified controls are disabled
    // const isAnyControlDisabled = disabledControls.some(control =>
    //   this.personalInfoForm?.get(control)?.disabled
    // );
    // if (isAnyControlDisabled) {
    //   event.preventDefault();
    // }
  }

}
